import React, { useCallback, useState } from "react";
import { Row, Col, Container, Form, Button } from 'react-bootstrap'
import { useUserContext } from "./contextProviders/userContext";

import '../../assets/css/revised_css/components/passwordChanger.css'
import { useNotificationContext } from "./contextProviders/notificationContext";
import { changePassword } from "../../services/network";

export function PasswordChanger() {
  const { user } = useUserContext()
  const [state, setState] = useState({ new: '', confirm: '', current: '' })
  const displayNotif = useNotificationContext()

  const onChange = useCallback((evt) => {
    setState({ ...state, [evt.target.name]: evt.target.value })
  }, [state])

  const onSubmit = useCallback(async () => {
    if (!state.current || !state.new || !state.confirm) return displayNotif('warning', 'Fill out all fields before submitting')
    if (state.new !== state.confirm) return displayNotif('warning', 'New passwords do not match')

    try {
      await changePassword(user, state.current, state.new)
      displayNotif('success', 'Password changed successfully!')
    } catch (e) {
      // console.log('Failed changing password', state, e)
      displayNotif('danger', `Failed changing password ${e.message}`)
    }
    setState({ new: '', confirm: '', current: '' })
  }, [state])

  return (
    <Container className="password-changer-container">
      <Form>
        <Row className="password-changer-header-row">
          {`Change Password For: ${user.firstName} ${user.lastName} (${user.username})`}
        </Row>
        <Row>
          <Col sm="2" className="label-col">
            <Form.Label>Current Password</Form.Label>
          </Col>
          <Col>
            <Form.Control type="password" name="current" value={state.current} onChange={onChange} aria-describedby="passwordHelpBlock" />
          </Col>
        </Row>
        <Row>
          <Col sm="2" className="label-col">
            <Form.Label>New Password</Form.Label>
          </Col>
          <Col>
            <Form.Control type="password" name="new" value={state.new} onChange={onChange} aria-describedby="passwordHelpBlock" />
          </Col>
        </Row>
        <Row>
          <Col sm="2" className="label-col">
            <Form.Label>Confirm New Password</Form.Label>
          </Col>
          <Col>
            <Form.Control type="password" name="confirm" value={state.confirm} onChange={onChange} aria-describedby="passwordHelpBlock" />
          </Col>
        </Row>
        <Row className="password-changer-footer-row">
          <Col sm="11">
            <Form.Text id="passwordHelpBlock" muted>
              Your password must:
              <ul>
                <li>
                  be at least 8 characters long
                </li>
                <li>
                  contain at least one lowercase and one uppercase letter
                </li>
                <li>
                  contain a number
                </li>
                <li>
                  contain at least one of #?!@$%^&*-
                </li>
                <li>
                  use only numbers, letters, and #?!@$%^&*-
                </li>
              </ul>
            </Form.Text>
          </Col>
          <Col className="password-changer-button-col"><Button variant="activated" onClick={onSubmit}>Submit</Button></Col>
        </Row>

      </Form>
    </Container>
  )
}